export default __webpack_public_path__ + "attention.9c6d0eca4a064505cab8.png";